import * as React from 'react';
import {
    Edit,
    BooleanInput,
    TextInput,
    ImageInput,
    ImageField,
    SimpleForm,
    ReferenceInput,
    AutocompleteInput,
    useTranslate,
} from 'react-admin';
import { Grid, Typography } from '@mui/material';

import Aside from './Aside';
import FullNameField from './FullNameField';

const EntityEdit = () => {
    const translate = useTranslate();

    return (
        <Edit
            title={<EditTitle />}
            aside={<Aside />}
            redirect={false}
            mutationMode="pessimistic"
        >
            <SimpleForm>
                <div>
                    <Grid
                        container
                        width={{ xs: '100%', xl: '80%' }}
                        spacing={2}
                    >
                        <Grid item xs={12} md={10} xl={12}>
                            <TextInput source="title" fullWidth />
                            <TextInput source="slug" fullWidth />
                            <BooleanInput source="active" fullWidth />
                            <ImageInput
                                source="image"
                                fullWidth
                                defaultValue={null}
                            >
                                <ImageField source="src" title="title" />
                            </ImageInput>
                            <TextInput
                                source="annotation"
                                fullWidth
                                multiline
                                maxRows={'10'}
                            />
                            <TextInput
                                source="content"
                                fullWidth
                                multiline
                                maxRows={'10'}
                            />
                            <TextInput
                                source="requirements"
                                fullWidth
                                multiline
                                maxRows={'10'}
                            />
                            <TextInput
                                source="responsibility"
                                fullWidth
                                multiline
                                maxRows={'10'}
                            />
                            <TextInput
                                source="cond"
                                fullWidth
                                multiline
                                maxRows={'10'}
                            />
                            <TextInput
                                source="address"
                                fullWidth
                                multiline
                                maxRows={'10'}
                            />
                            <ReferenceInput source="city_id" reference="cities">
                                <AutocompleteInput
                                    optionText="title"
                                    fullWidth
                                />
                            </ReferenceInput>
                            <Typography variant="h6" gutterBottom>
                                {translate('resources.pages.fieldGroups.seo')}
                            </Typography>
                            <TextInput source="seo_h1" fullWidth />
                            <TextInput
                                source="seo_description"
                                fullWidth
                                multiline
                                maxRows={'10'}
                            />
                            <BooleanInput source="seo_no_index" fullWidth />
                            <TextInput source="seo_canonical" fullWidth />
                        </Grid>
                    </Grid>
                </div>
            </SimpleForm>
        </Edit>
    );
};

// @ts-ignore
const EditTitle = () => <FullNameField size="32" sx={{ margin: '5px 0' }} />;

export default EntityEdit;
